import { render, staticRenderFns } from "./CCMLabsAdd.vue?vue&type=template&id=21daf393"
import script from "./CCMLabsAdd.vue?vue&type=script&lang=js"
export * from "./CCMLabsAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports